import { z } from 'zod'

export const clientSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  contact_person: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().email('Invalid email').optional().or(z.literal('')),
  contract_start_date: z.string().min(1, 'Contract start date is required'),
  baseline_ar_total: z.coerce.number().min(0, 'Must be a positive number'),
  implementation_tier: z.enum(['tier1', 'tier2', 'tier3', 'tier4']),
  implementation_fee: z.coerce.number().min(0),
  status: z.enum(['active', 'inactive', 'pending']).default('active'),
})

export type ClientFormData = z.infer<typeof clientSchema>

export const IMPLEMENTATION_TIERS = [
  { value: 'tier1', label: 'Tier 1 (1-25 accounts) - $1,500', fee: 1500 },
  { value: 'tier2', label: 'Tier 2 (26-75 accounts) - $3,500', fee: 3500 },
  { value: 'tier3', label: 'Tier 3 (76-150 accounts) - $6,500', fee: 6500 },
  { value: 'tier4', label: 'Tier 4 (150+ accounts) - $10,000', fee: 10000 },
]
